<template>
  <div class="field">
    <label class="label">Contact Email</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactEmail',
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    companyId: {
      type: Number,
      required: true
    },
    isDryRun: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        if (this.isDryRun) {
          return
        }
        await this.$network_utils.updateCompany({ id: this.companyId, contact_email: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
